// extracted by mini-css-extract-plugin
export var PrimaryButton = "footer-module--PrimaryButton--a6551";
export var SecondaryButton = "footer-module--SecondaryButton--89ea4";
export var footer = "footer-module--footer--965a8";
export var footerContainer = "footer-module--footerContainer--51e70";
export var item = "footer-module--item--36fda";
export var section = "footer-module--section--e3f93";
export var sectionTitle = "footer-module--sectionTitle--aeadd";